<div *ngIf="loading" class="padding">
  <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
</div>
<ng-container *ngIf="!loading">
  <div class="contractData-layout">
    <div class="col-left col-sm-4 col-md-3" [collapse]="isMobile && isCollapsed" id="contract-menu">
      <gp-back-link
        *ngIf="!isEss"
        [linkText]="'MSS.back_to_employee_list'"
        (linkClick)="onBackLinkClick()">
      </gp-back-link>

      <div class="col-left--header p-a-sm">
        <label>
          <gp-user-avatar [pictureUri]="photoLink?.href"
                          [initials]="(employeeFirstName?.charAt(0) || '') + (employeeLastName?.charAt(0) || '')"
                          size="lg">
          </gp-user-avatar>
        </label>
        <div class="col-left--name">
          <div class="max-w-75">
            <h3 [class.non-active]="isInactiveContract" class="break-word">
              {{ employeeFirstName }} <span class="font-weight-bold">{{ employeeLastName }}</span>
            </h3>
          </div>
          <gp-contract-employee-menu
            [cliRegId]="selectedContract?.cliRegID"
            [contractId]="selectedContract?.id"
            [contract]="selectedContract"
            [profileType]="profileType"
            [readOnly]="true">
          </gp-contract-employee-menu>
        </div>
        <div *ngIf="isEss" class="col-left--select">
          <gp-dropdown-select
            [ngModel]="selectedContract"
            [customPlaceholderGenerator]="customPlaceholderGenerator"
            (ngModelChange)="selectContract($event)"
            buttonClasses="btn-sm"
            ngDefaultControl>
            <gp-dropdown-option *ngFor="let contract of contracts"
                                [ngValue]="contract"
                                [class.non-active]="isContractInactive(contract)">
              <img class="flag-icon" alt="flag-icon"
                   *ngIf="contract.flag"
                   [attr.src]="contract.flag.href"/>
              {{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: contract.cliRegNickName} }}
              {{ getContractDate(contract) }}
            </gp-dropdown-option>
          </gp-dropdown-select>
        </div>
      </div>
      <gp-contract-data-group-menu
        *ngIf="descriptor?.tabSheets?.length; else noContent"
        (selectedTabSheetWithGroupZoneChange)="selectGroupZone($event.tabSheet, $event.groupZone)"
        [activeGroupZone]="activeGroupZone"
        [activeTabSheet]="activeTabSheet"
        [descriptor]="descriptor">
      </gp-contract-data-group-menu>
    </div>
    <div class="col-right col-sm-8 col-md-9" *ngIf="isCollapsed && descriptor?.tabSheets?.length">
      <h4 class="col-right--header">
          <span>
            <em class="fa fa-light fa-angle-left"
                (click)="isCollapsed = !isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="contract-menu"
                *ngIf="isMobile">
            </em>
            {{activeGroupZone?.transId | translate}}
          </span>
        <button (click)="addOrEditCard()"
                *ngIf="activeGroupZone?.groupZoneID !== 'Attachments' && (activeGroupZone?.isDated || isMultipleCardType)"
                [disabled]="activeGroupZone?.readOnly || isInactiveContract"
                class="btn primary add-btn"
                type="button">
          <em class="fa fa-light fa-plus-circle"></em>
          <span *ngIf="!isMobile" class="m-l-sm">{{'NOTIFICATIONS.add' | translate}}</span>
        </button>
      </h4>
      <div *ngIf="groupNamesInValidation.includes(activeGroupZone?.groupZoneID)" class="col-right--warning">
        <em class="fa fa-light fa-clock text-warning m-r-sm"></em>
        <span>{{ 'WORKFLOWS.data_in_validation' | translate }}</span>
      </div>
      <div *ngIf="activeGroupZone?.groupZoneID !== 'Attachments'; else attachementsTab">
        <gp-contract-data-card
          (edit)="addOrEditCard($event)"
          *ngFor="let card of cards"
          [activeGroupZone]="activeGroupZone"
          [card]="card"
          [class.col-md-12]="cards.length===1"
          [contracts]="contracts"
          [isInactiveContract]="isInactiveContract"
          [isMultipleCardType]=isMultipleCardType
          [profileMode]="isEss ? profileModes.ESS : profileModes.MSS"
          class="col-md-6">
        </gp-contract-data-card>
      </div>
      <ng-template #attachementsTab>
        <gp-attachments class="col-md-6 col-md-12 col-xs-12" [contractId]="contractId" [empValues]="contractData"
                        [isReadOnly]="true" [profileMode]="isEss ? profileModes.ESS : profileModes.MSS"></gp-attachments>
      </ng-template>
    </div>
  </div>
  <ng-template #noContent>
    <gp-back-link
      *ngIf="!isEss"
      [linkText]="'MSS.back_to_employee_list'"
      (linkClick)="onBackLinkClick()">
    </gp-back-link>
    <div class="padding">
      <gp-message text="COMMON.No_data_for_contract" type="info"></gp-message>
    </div>
  </ng-template>
</ng-container>

<gp-modal gp-modal="edit-card"
          [closable]="false"
          #editPopup>
  <div class="gp-modal-title">
    {{ activeGroupZone?.transId | translate }}
  </div>
  <form novalidate class="gp-modal-body clearfix">
    <div #fieldComponent></div>

    <div class="col-xs-12" *ngIf="activeGroupZone?.isDated">
      <div class="form-group">
        <label>
          {{ 'EMPLOYEE_MANAGE.effective_date' | translate }}
          <span class="required">*</span>
        </label>

        <datepicker-input [formControl]="effectiveDateControl"
                          [minDate]="minDate"
                          [maxDate]="maxDate"
                          [hasEternity]="true"
                          [groupZoneID]="activeGroupZone?.groupZoneID"
                          [groupZoneDescriptor]="activeGroupZone">
        </datepicker-input>
      </div>
    </div>
  </form>
  <div class="gp-modal-footer" *ngIf="!saving">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button"
                class="btn btn-dark p-x-md"
                (click)="sendCardData(editPopup)"
                [disabled]="form?.invalid || (!isFormDirty && activeGroupZone?.internalType !== 'BANKING_DETAILS')">
          {{ 'EMPLOYEE_FORM.submit' | translate }}
        </button>
        <button type="button"
                class="btn btn-secondary p-x-md"
                (click)="cancelCardEdit(editPopup)">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>

  </div>
  <div class="gp-modal-footer" *ngIf="saving">
    <div class="pull-right">
      <i class="fa fa-light fa-spinner fa-spin"></i>
    </div>
  </div>
</gp-modal>
